var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('media-manager',{attrs:{"title":'Manuals',"containers":[_vm.manualsContainer],"defaultContainer":_vm.manualsContainer.name,"disabledContentTypes":['image', 'audio']}})}
var staticRenderFns = []

export { render, staticRenderFns }